// document.querySelectorAll('.variant-option__button-label__text').forEach(el => {
//   const map = {
//     'Extra-Small': 'XS',
//     'Small': 'S',
//     'Medium': 'M',
//     'Large': 'L',
//     'Extra-Large': 'XL'
//   };

//   if (map[el.textContent.trim()]) {
//     el.textContent = map[el.textContent.trim()];
//   }
// });

  



// Start bundle

document.addEventListener('DOMContentLoaded', function () {

  const productItems = document.querySelector('.bundle-remaining-count');

    let maxiProd;

    if (productItems) {
      maxiProd = productItems.textContent.trim();
      console.log("maxi_prod:", maxiProd);
    } else {
      console.log("Element not found");
    }

    const MAX_PRODUCTS = 5;

   let selectedProducts = [];

  const productCards = document.querySelectorAll('.sample-product-card');
  const slots = document.querySelectorAll('.bundle-slot');
  const remainingCount = document.querySelector('.bundle-remaining-count');
  const bundleAddButton = document.querySelector('.bundle-add-all-btn');

  function removeSelectedSlot(index) {
    if (index < 0 || index >= selectedProducts.length) {
      return;
    }

    // Remove selected product
    selectedProducts.splice(index, 1);

    // Update all slots and product cards
    updateBundleUI();
  }


  function updateBundleUI() {
    slots.forEach(function (slot, index) {
      const plus = slot.querySelector('.bundle-slot-plus');
      const image = slot.querySelector('.bundle-slot-image');
      const removeButton = slot.querySelector('.bundle-slot-remove');
      const product = selectedProducts[index];

      if (product) {
        slot.classList.add('filled');

        if (plus) {
          plus.style.display = 'none';
        }

        if (image) {
          image.src = product.image;
          image.alt = product.title;
          image.style.display = 'block';
        }

        // Show remove button for selected slot
        if (removeButton) {
          removeButton.style.display = 'flex';

          // Remove this specific slot
          removeButton.onclick = function (e) {
            e.preventDefault();
            e.stopPropagation();

            removeSelectedSlot(index);
          };
        }

      } else {
        slot.classList.remove('filled');

        if (plus) {
          plus.style.display = 'flex';
        }

        if (image) {
          image.src = '';
          image.alt = '';
          image.style.display = 'none';
        }

        // Hide remove button for empty slot
        if (removeButton) {
          removeButton.style.display = 'none';
          removeButton.onclick = null;
        }
      }
    });

    const remaining = MAX_PRODUCTS - selectedProducts.length;

    if (remainingCount) {
      remainingCount.textContent = remaining;
    }

    if (bundleAddButton) {
      bundleAddButton.textContent =
        remaining > 0
          ? `Add to cart`
          : 'Add Bundle to Cart';

      // bundleAddButton.disabled =
      //   selectedProducts.length !== MAX_PRODUCTS;
    }

    // Update product cards
    productCards.forEach(function (card) {
      const addButton = card.querySelector('.sample-add-btn');
      const variantSelect = card.querySelector('.sample-variant');
      const productId = card.dataset.productId;

      const isSelected = selectedProducts.some(function (product) {
        return product.productId == productId;
      });

      if (isSelected) {
        card.classList.add('selected');

        if (addButton) {
          addButton.disabled = true;
        }

        if (variantSelect) {
          variantSelect.disabled =
            selectedProducts.length >= MAX_PRODUCTS;
        }

      } else {
        card.classList.remove('selected');

        if (addButton) {
          addButton.disabled =
            selectedProducts.length >= MAX_PRODUCTS;
        }

        if (variantSelect) {
          variantSelect.disabled =
            selectedProducts.length >= MAX_PRODUCTS;
        }
      }
    });
  }

  productCards.forEach(function (card) {
    const addButton = card.querySelector('.sample-add-btn');
    const variantSelect = card.querySelector('.sample-variant');

    if (!addButton) {
      return;
    }

    addButton.addEventListener('click', function (e) {
      e.preventDefault();

      if (selectedProducts.length >= MAX_PRODUCTS) {
        alert(`You can select only ${MAX_PRODUCTS} products.`);
        return;
      }

      document.querySelector(".featured-next-btn").disabled = false;

      if (variantSelect && !variantSelect.value) {
        alert('Please select a size.');
        variantSelect.focus();
        return;
      }

      let variantId = addButton.dataset.variant;

      if (variantSelect) {
        variantId = variantSelect.value;
      }

      if (!variantId) {
        alert('Please select a variant.');
        return;
      }

      let productImage =
        card.querySelector('.sample-product-image img')?.src || '';

      if (variantSelect) {
        const selectedOption =
          variantSelect.options[variantSelect.selectedIndex];

        if (
          selectedOption &&
          selectedOption.dataset.image
        ) {
          productImage = selectedOption.dataset.image;
        }
      }

      const productId = card.dataset.productId;

      const alreadySelected = selectedProducts.some(function (product) {
        return product.productId == productId;
      });

      // if (alreadySelected) {
      //   alert('This product is already selected.');
      //   return;
      // }

      selectedProducts.push({
        productId: productId,
        variantId: variantId,
        image: productImage,
        title:
          card.querySelector('h4')?.textContent.trim() || ''
      });

      updateBundleUI();

      const accordion =
        document.querySelector('accordion-custom.ac-details');

      if (accordion) {
        accordion.style.pointerEvents = 'auto';
      }

      document
        .querySelectorAll('.sample-product-card')
        .forEach(function (card) {
          card.classList.remove('active');
        });

      card.classList.add('active');

      if( selectedProducts.length == MAX_PRODUCTS){
      document
        .querySelectorAll('accordion-custom details')
        .forEach(function (details) {
          details.removeAttribute('open');
        });
      }
      const targetDetails =
        document.querySelector(
          'accordion-custom.ac-details details'
        );

      if( selectedProducts.length == MAX_PRODUCTS){
      if (targetDetails) {
        targetDetails.setAttribute('open', '');

        setTimeout(function () {
          const headerOffset = 500;

          const topPosition =
            targetDetails.getBoundingClientRect().top +
            window.pageYOffset -
            headerOffset;

          window.scrollTo({
            top: topPosition,
            behavior: 'smooth'
          });
        }, 180);
      }
      }
    });
  });

  document.querySelectorAll('.sample-remove').forEach(function (removeButton) {
        removeButton.addEventListener('click', function (e) {
          e.preventDefault();

          const card =
            this.closest('.sample-product-card');

          if (!card) {
            return;
          }

          const productId = card.dataset.productId;

          const selectedIndex =
            selectedProducts.findIndex(function (product) {
              return product.productId == productId;
            });

          if (selectedIndex === -1) {
            return;
          }

          selectedProducts.splice(selectedIndex, 1);

          card.classList.remove('selected');

          const addButton =
            card.querySelector('.sample-add-btn');

          if (addButton) {
            addButton.disabled = false;
          }

          const select =
            card.querySelector('.sample-variant');

          if (select) {
            select.value = '';
            select.disabled = false;
          }

          updateBundleUI();
        });
    });

  

    if (bundleAddButton) {
      bundleAddButton.addEventListener('click',async function () {
          // if (selectedProducts.length !== MAX_PRODUCTS) {
          //   alert(`Please select ${MAX_PRODUCTS} products.`);
          //   return;
          // }


           window.loadConfirmation();

          const customerProperties = {
            "Full Name": document.querySelector(".c-name").textContent.trim(),
            "Practice Name": document.querySelector(".c-practice").textContent.trim(),
            "Full Address": document.querySelector(".c-address").textContent.trim(),
            "Zip Code": document.querySelector(".c-zip-code").textContent.trim(),
            "Email Address": document.querySelector(".c-email").textContent.trim(),
            "Phone Number": document.querySelector(".c-phone").textContent.trim(),
            "Specialisation": document.querySelector(".c-specialisation").textContent.trim(),
            "Current Gloves Vendor": document.querySelector(".c-vendor").textContent.trim(),
            "What Matters Most": Array.from(
              document.querySelectorAll('input[name="matters[]"]:checked')
            ).map(cb => cb.value).join(", ")
          };


          const items =
            selectedProducts.map(function (product) {
              return {
                id: Number(product.variantId),
                quantity: 1,
                properties: {
                  '_Bundle': 'true',
                  ...customerProperties
                }
              };
            });

          bundleAddButton.disabled = true;
          // bundleAddButton.textContent = 'Adding...';

          try {
            const response =
              await fetch(
                `${Shopify.routes.root}cart/add.js`,
                {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                  },
                  body: JSON.stringify({
                    items: items,
                    properties: {
                    "Full Name": document.querySelector(".c-name").textContent.trim(),
                    "Practice Name": document.querySelector(".c-practice").textContent.trim(),
                    "Full Address": document.querySelector(".c-address").textContent.trim(),
                    "Zip Code": document.querySelector(".c-zip-code").textContent.trim(),
                    "Email Address": document.querySelector(".c-email").textContent.trim(),
                    "Phone Number": document.querySelector(".c-phone").textContent.trim(),
                    "Specialisation": document.querySelector(".c-specialisation").textContent.trim(),
                    "Current Gloves Vendor": document.querySelector(".c-vendor").textContent.trim(),
                    "What Matters Most": Array.from(
                        document.querySelectorAll('input[name="matters[]"]:checked')
                    ).map(cb => cb.value).join(", ")
                }
                  })
                }
              );

            if (!response.ok) {
              const error = await response.json();
              console.error('Cart error:', error);
              throw new Error('Unable to add bundle');
            }

            await response.json();

            selectedProducts = [];

            productCards.forEach(function (card) {
              const select =
                card.querySelector('.sample-variant');

              if (select) {
                select.value = '';
                select.disabled = false;
              }
            });

            updateBundleUI();
            window.refreshCart();

          } catch (error) {
            console.error('Bundle error:', error);

            alert(
              'Something went wrong. Please try again.'
            );

            bundleAddButton.disabled = false;
            updateBundleUI();
          }
        }
      );
    }

  updateBundleUI();

});


  window.loadConfirmation = () =>  {
    // Form Values
    const firstName = document.querySelector('[name="first_name"]').value;
    const lastName = document.querySelector('[name="last_name"]').value;

    document.querySelector('.c-name').textContent = firstName + ' ' + lastName;

    document.querySelector('.c-practice').textContent = document.querySelector('[name="practice_name"]').value;

    document.querySelector('.c-phone').textContent = document.querySelector('[name="phone"]').value;

    document.querySelector('.c-email').textContent = document.querySelector('[name="email"]').value;

    document.querySelector('.c-specialisation').textContent = document.querySelector('[name="specialisation"]').value;

    document.querySelector('.c-address').textContent =
      document.querySelector('[name="address"]').value + ', ' + document.querySelector('[name="zipcode"]').value;

    document.querySelector('.c-zip-code').textContent = document.querySelector('[name="zipcode"]').value;
     document.querySelector('.c-vendor').textContent = document.querySelector('[name="vendor"]').value;

    // Selected Product
    const card = document.querySelector('.sample-product-card.active');

   
    if (card) {
      const imageEl = card.querySelector('img');
      const titleEl = card.querySelector('h4');
      const sizeEl = card.querySelector('.sample-variant option:checked');
      const confirmProductEl = document.querySelector('.confirm-product');

      const image = imageEl?.src;
      const title = titleEl?.textContent?.trim();
      const size = sizeEl?.textContent?.trim();

      if (!image || !title || !size || !confirmProductEl) {
        console.warn('Missing product confirmation data', {
          imageEl,
          titleEl,
          sizeEl,
          confirmProductEl
        });
        return;
      }

      confirmProductEl.innerHTML = `
        <div class="confirm-product-card">
          <img src="${image}" width="60">

          <div>
            <h4>${title}</h4>
            <p>Size : ${size}</p>
          </div>
        </div>
      `;
    }

  }


// END Bundle




  window.refreshCart = async () => {
    try {

      // Fetch updated cart with rendered sections
      const response = await fetch(
        "/cart.js?sections=cart-drawer,cart-icon-bubble,cart-items"
      );

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}`);
      }

      const cart = await response.json();

      console.log("Updated Cart:", cart);

      // Notify Horizon theme
      document.dispatchEvent(
        new CustomEvent("cart:update", {
          detail: {
            data: cart
          }
        })
      );

      // Open drawer
      setTimeout(() => {
        document.querySelector("cart-drawer-component")?.open();
      }, 500);

    } catch (e) {
      console.error("refreshCart error", e);
    }
  };

// document.querySelectorAll('.price').forEach(price => { price.textContent = price.textContent.replace(/\s*USD/g, ''); });

const step_divs = document.querySelectorAll('.sample-steps .steps ');

// Find the maximum height
let maxHeight = 0;

step_divs.forEach(div => {
  maxHeight = Math.max(maxHeight, div.offsetHeight);
});

// Apply maximum height to all divs
step_divs.forEach(div => {
  div.style.height = `${maxHeight}px`;
});
 

document.addEventListener('DOMContentLoaded', function () {
  const totalPrice = document.querySelector('#product-total-price');

  if (!totalPrice) return;

  const priceContainer = document.querySelector(
    '.product-details .product__price'
  );

  if (!priceContainer) return;

  /* =====================================================
     GET B2B PRICE
  ===================================================== */
 setTimeout(function(){

 
  const priceElement = document.querySelector(
    'product-price[bss-b2b-product-price]'
  );

  const b2bPrice = priceElement
    ?.querySelectorAll('span')[1]
    ?.textContent
    .trim();

  console.log(b2bPrice, '--b2bPrice11');
  //totalPrice.textContent =b2bPrice;

},3000);
  /* =====================================================
     GET PRICE
  ===================================================== */

  function updateTotal() {
    const quantityInput = document.querySelector(
      '.quantity-selector input[name="quantity"]'
    );

    if (!quantityInput || !totalPrice) return;

    /* -----------------------------------------------
       B2B PRICE
    ----------------------------------------------- */

    const priceElement = document.querySelector(
      'product-price[bss-b2b-product-price]'
    );

    let priceText = '';

    if (priceElement) {
      const spans = priceElement.querySelectorAll('span');

      if (spans[1]) {
        priceText = spans[1].textContent.trim();
      }
    }

    /* -----------------------------------------------
       FALLBACK NORMAL PRICE
    ----------------------------------------------- */

    if (!priceText) {
      priceText = priceContainer.textContent.trim();
    }

    console.log(
      priceText,
      '--priceText'
    );

    /* -----------------------------------------------
       CONVERT PRICE
    ----------------------------------------------- */

    const price = parseFloat(
      priceText.replace(/[^0-9.]/g, '')
    );

    if (!Number.isFinite(price)) {
      return;
    }

    /* -----------------------------------------------
       QUANTITY
    ----------------------------------------------- */

    const quantity =
      parseInt(quantityInput.value, 10) || 1;

    /* -----------------------------------------------
       TOTAL
    ----------------------------------------------- */

    const total = price * quantity;

    totalPrice.textContent =
      '$' + total.toFixed(2);
  }

  /* =====================================================
     INITIAL PRICE
  ===================================================== */

  updateTotal();

  /* =====================================================
     QUANTITY + / -
  ===================================================== */

  document.addEventListener('click', function (e) {
    if (
      e.target.closest('.quantity-plus') ||
      e.target.closest('.quantity-minus')
    ) {
      setTimeout(function () {
        updateTotal();
      }, 100);
    }
  });

  /* =====================================================
     DIRECT QUANTITY CHANGE
  ===================================================== */

  // const quantityInput = document.querySelector(
  //   '.quantity-selector input[name="quantity"]'
  // );

  // if (quantityInput) {
  //   quantityInput.addEventListener(
  //     'change',
  //     updateTotal
  //   );

  //   quantityInput.addEventListener(
  //     'input',
  //     updateTotal
  //   );
  // }
  document.addEventListener('input', function (e) {
  if (e.target.matches('.quantity-selector input[name="quantity"]')) {
    updateTotal();
  }
});

document.addEventListener('change', function (e) {
  if (e.target.matches('.quantity-selector input[name="quantity"]')) {
    updateTotal();
  }
});
});
document.addEventListener(
    "click",
    function (event) {

      const button =
        event.target.closest(
          "quantity-selector-component button"
        );

      if (!button) {
        return;
      }

      console.log(
        "Quantity button clicked 222"
      );           
    setTimeout(function(){
      updateqtyTotal_quick();
      },0);
})



document.addEventListener('input', e => {
  //console.log('target:', e.target);
  //console.log('path:', e.composedPath());
  if (e.target.matches('.quantity-selector input[name="quantity"]')) {
    setTimeout(function(){
   updateqtyTotal_quick();
   },1000);
  }
});
function updateqtyTotal_quick(){
    const quantityInput = document.querySelector(
      '.quantity-selector input[name="quantity"]'
    );
    const totalPrice = document.querySelector('#product-total-price');

  if (!totalPrice) return;

  const priceContainer = document.querySelector(
    '.product-details .product__price'
  );

  if (!priceContainer) return;


    if (!quantityInput || !totalPrice) return;

    /* -----------------------------------------------
       B2B PRICE
    ----------------------------------------------- */

    const priceElement = document.querySelector(
      'product-price[bss-b2b-product-price]'
    );

    let priceText = '';

    if (priceElement) {
      const spans = priceElement.querySelectorAll('span');

      if (spans[1]) {
        priceText = spans[1].textContent.trim();
      }
    }

    /* -----------------------------------------------
       FALLBACK NORMAL PRICE
    ----------------------------------------------- */

    if (!priceText) {
      priceText = priceContainer.textContent.trim();
    }

    console.log(
      priceText,
      '--priceText'
    );

    /* -----------------------------------------------
       CONVERT PRICE
    ----------------------------------------------- */

    const price = parseFloat(
      priceText.replace(/[^0-9.]/g, '')
    );

    if (!Number.isFinite(price)) {
      return;
    }

    /* -----------------------------------------------
       QUANTITY
    ----------------------------------------------- */

    const quantity =
      parseInt(quantityInput.value, 10) || 1;

    /* -----------------------------------------------
       TOTAL
    ----------------------------------------------- */

    const total = price * quantity;

    totalPrice.textContent =
      '$' + total.toFixed(2);
}


